import { Table, TableContainer } from '@mui/material';
import React, { useState } from 'react';
import UpdateStaffTableHeader from './UpdateStaffTableHeader';
import UpdateStaffTableBody from './UpdateStaffTableBody';
import { tableContainerStyle, tableStyle } from './UpdateStaffTableStyles';

const UpdateStaffTable = ({ items, selectedStaffs, toggleCheck, setSort, sort, nowFilter, isAllSelected, onSelectAll, onRoleChange, windowWidth, isSupervisor, originalStaffs }) => {
  const [hoveredColumn, setHoveredColumn] = useState(null);

  return (
    <TableContainer className='field-setting-staff-update-popup-table' sx={{ ...tableContainerStyle, overflow: 'auto', maxHeight: windowWidth < 1919 ? '390px' : '480px' }}>
      <Table stickyHeader sx={tableStyle}>
        <UpdateStaffTableHeader
          setSort={setSort}
          sort={sort}
          hoveredColumn={hoveredColumn}
          setHoveredColumn={setHoveredColumn}
          isAllSelected={isAllSelected}
          onSelectAll={onSelectAll}
          isSupervisor={isSupervisor}
          originalStaffs={originalStaffs}
          items={items}
        />
        <UpdateStaffTableBody
          items={items}
          selectedStaffs={selectedStaffs}
          toggleCheck={toggleCheck}
          nowFilter={nowFilter}
          onRoleChange={onRoleChange}
          isSupervisor={isSupervisor}
          originalStaffs={originalStaffs}
        />
      </Table>
    </TableContainer>
  );
};

export default UpdateStaffTable;
